/**
 * Leyenda de colores del horario (presentacional).
 *
 * Réplica de la leyenda del SSR (`schedule.html`): el color de cada celda según el
 * número de órdenes pendientes. Sin lógica de datos. El texto se adapta levemente al
 * modo láser (igual que el SSR, que decía "órdenes láser pendientes").
 */
interface ScheduleLegendProps {
  /** Modo láser: ajusta el texto de la leyenda (réplica del SSR). */
  laser?: boolean;
}

export function ScheduleLegend({ laser = false }: ScheduleLegendProps) {
  const kind = laser ? "órdenes láser" : "órdenes";
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-lg border border-slate-200 bg-white p-3 text-sm">
      <span className="font-semibold text-slate-700">Leyenda:</span>
      <span className="inline-flex items-center gap-2">
        <span className="inline-block h-3 w-3 rounded-full bg-emerald-500" aria-hidden="true" />
        <span className="text-slate-600">Verde (1-2): pocas {kind} pendientes</span>
      </span>
      <span className="inline-flex items-center gap-2">
        <span className="inline-block h-3 w-3 rounded-full bg-amber-400" aria-hidden="true" />
        <span className="text-slate-600">Amarillo (3-4): {kind} moderadas</span>
      </span>
      <span className="inline-flex items-center gap-2">
        <span className="inline-block h-3 w-3 rounded-full bg-red-500" aria-hidden="true" />
        <span className="text-slate-600">Rojo (5+): muchas {kind} pendientes</span>
      </span>
      <span className="inline-flex items-center gap-2">
        <span className="inline-block h-3 w-3 rounded-full bg-slate-400" aria-hidden="true" />
        <span className="text-slate-600">Gris: solo entregadas</span>
      </span>
    </div>
  );
}
